import { Injectable } from '@angular/core';
import { AppCollection } from '../../app.config';
import { BaseCollectionService } from '../../core/jsonApi/BaseCollectionService';
import { ExplanationContentJsonModel } from './explanation-content.json.model';

@Injectable({
  providedIn: 'root'
})
export class ExplanationContentService extends BaseCollectionService<ExplanationContentJsonModel, AppCollection> {
  protected ctor = ExplanationContentJsonModel;
}
